import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '@shakkerai/components';
import { translate } from '@shakkerai/util-i18n';
import { useModelsModalState } from '../../../../store/state';
import { modalType } from '../../../../constants';

const Seacher = React.memo(({ value, onChange, modelType }) => {
  const [keyword, setKeyword] = useState();
  const ref = useRef(null);
  const isInGlobalSearchState = useModelsModalState('isInGlobalSearchState');
  useEffect(() => {
    setKeyword(value);
  }, [value]);

  const handleInputKeyword = (e) => {
    setKeyword(e.target.value);
  };

  const handleClearKeyword = (e) => {
    setKeyword('');
    ref.current.focus();
    onChange({ keyword: '', collectState: {}, isInGlobalSearchState: true });
    e.stopPropagation();
  };

  return (
    <div className="flex w-[40%]">
      <div
        className={`relative w-full flex items-center min-w-[280px] flex-shrink-0 h-[36px] px-3 bg-[#fff] border border-[#ededed] focus-within:border-primary rounded`}
      >
        <Icon className="shk-danchuang-sousuo" fontSize={16} color="#ADADAD" />
        <input
          ref={ref}
          maxLength={40}
          value={keyword}
          placeholder={modelType === modalType.WORKFLOW ? '' : translate('search_model_placeholder')}
          className="flex-1 mx-2 pr-2 bg-transparent text-[13px]"
          onKeyDown={(e) => e.key === 'Enter' && onChange({ keyword, collectState: {}, isInGlobalSearchState: true })}
          onChange={handleInputKeyword}
          onMouseDown={(e) => e.stopPropagation()}
        />
        <div className="flex">
          {keyword && (
            <button
              onClick={handleClearKeyword}
              className="hover:bg-[#bbb] flex items-center justify-center relative top-[3px] right-[12px] w-[14px] h-[14px] rounded-full bg-black/20"
            >
              <Icon className="shk-prompt-lora-guanbi scale-50 " fontSize={14} color="#fff" />
            </button>
          )}
          <i className="w-[1px] h-[14px] mr-[12px] relative top-[3.5px] block bg-[#D9D9D9]" />
          <button
            onClick={() => onChange({ keyword, collectState: {}, isInGlobalSearchState: true })}
            className="hover:text-[#2d2d2d] right-[8px] text-[#7a7a7a] flex justify-center items-center text-[13px]"
          >
            {translate('common_search')}
          </button>
        </div>
      </div>
      {isInGlobalSearchState && (
        <button
          onClick={() => onChange({ keyword: '', isInGlobalSearchState: false, globalSearchDataCount: 0 })}
          className="flex-shrink-0 text-[#7a7a7a] flex justify-center items-center ml-3 hover:text-[#2d2d2d] text-[13px]"
        >
          {translate('cancel')}
        </button>
      )}
    </div>
  );
});

export default Seacher;
